export default __webpack_public_path__ + "static/media/A.9c71e995.png";